import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsVisibleDisabledNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M.225 1.108L14.89 15.775l.884-.884-2.847-2.847c.248-.209.48-.424.696-.64a13.583 13.583 0 002.266-3.04.774.774 0 000-.729 13.582 13.582 0 00-2.266-3.04C12.32 3.292 10.42 2 8 2c-1.514 0-2.825.505-3.913 1.203L1.11.225zm4.77 3.003C5.873 3.594 6.878 3.25 8 3.25c1.953 0 3.553 1.042 4.74 2.23A12.487 12.487 0 0114.663 8c-.28.489-.937 1.533-1.923 2.52-.22.22-.452.434-.699.637l-1.524-1.524a3 3 0 00-4.15-4.15zm2.29 2.29a1.75 1.75 0 012.312 2.312zM.11 7.635c.173-.325.874-1.58 2.053-2.82l.884.884c-.869.919-1.45 1.848-1.71 2.3.28.49.936 1.534 1.923 2.521 1.187 1.188 2.787 2.23 4.74 2.23.637 0 1.237-.111 1.797-.302l.965.966A6.872 6.872 0 018 14c-2.42 0-4.32-1.291-5.624-2.596A13.58 13.58 0 01.11 8.364a.774.774 0 010-.729z" />
        <path d="M5 8c0-.112.006-.222.018-.33l3.312 3.312A3 3 0 015 8z" />
      </g>
    </svg>
  )
);
SvgActionsVisibleDisabledNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsVisibleDisabledNormalXsmall;
